module.exports = __webpack_public_path__ + "static/easybroker-c043fa4bcf2b482771c8a44b9cf05768.jpg";